import { createFileRoute, redirect } from "@tanstack/react-router";
import * as db from "@/lib/db.server";

export const Route = createFileRoute("/api/public/upgrade/$token")({
  server: {
    handlers: {
      GET: async ({ request, params }) => {
        const token = (params as any).token as string;
        const base = process.env.PUBLIC_SITE_URL?.replace(/\/$/, "") || "https://heallexa.com";

        if (!token || token.length < 16) {
          return Response.redirect(`${base}/login?reason=upgrade-link-invalid`, 302);
        }

        const tok = await db.one(
          `SELECT id, provider_id, enrollment_id, step_id, expires_at, revoked, upgrade_completed_at
             FROM public.provider_upgrade_tokens
            WHERE token = $1`,
          [token],
        );

        if (!tok || tok.revoked || tok.upgrade_completed_at || new Date(tok.expires_at) < new Date()) {
          return Response.redirect(`${base}/login?reason=upgrade-link-expired`, 302);
        }

        const url = new URL(request.url);
        const now = new Date().toISOString();

        await db.execute(
          `UPDATE public.provider_upgrade_tokens
              SET clicked_at = $2,
                  upgrade_started_at = $3
            WHERE id = $1`,
          [tok.id, now, now],
        );


        await db.execute(
          `INSERT INTO public.email_click_events
             (token, provider_id, enrollment_id, step_id, ip, ua, referer)
           VALUES ($1, $2, $3, $4, $5, $6, $7)`,
          [
            token,
            tok.provider_id,
            tok.enrollment_id,
            tok.step_id,
            request.headers.get("x-forwarded-for") ?? null,
            request.headers.get("user-agent") ?? null,
            request.headers.get("referer") ?? null,
          ],
        );

        await db.execute(
          `INSERT INTO public.email_sequence_events
             (enrollment_id, step_id, kind, meta)
           VALUES ($1, $2, $3, $4)`,
          [
            tok.enrollment_id,
            tok.step_id,
            "clicked",
            JSON.stringify({ token_id: tok.id, ua: url.searchParams.get("src") ?? null }),
          ],
        );

        // Redirect into the dashboard upgrade flow with the provider id pre-filled.
        const dest = `${base}/dashboard/doctor?upgrade=premium&from=email&pid=${tok.provider_id}&t=${token}`;
        return Response.redirect(dest, 302);
      },
    },
  },
  component: () => null,
});
